import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
// import { PageSectionHeader } from '../../structure/page-blocks';
import { FormEngine } from '../../form/formengine';
/**
 * ComponentPropertiesForm - Displays the component properties form
 * Shows FormEngine when component is selected, placeholder otherwise
 */
/**
 * ComponentPropertiesForm — Display and edit the selected component's properties using FormEngine.
 *
 * @param {object} [props.editableComponent] - JSON schema for the currently selected component (contains `fields`).
 * @param {function} [props.onSubmit] - Callback invoked when the edited component is saved; receives the component schema.
 */
ComponentPropertiesForm.propTypes = {
    /** JSON schema for the currently selected component */
    editableComponent: PropTypes.object,
    /** Callback invoked when component properties are submitted */
    onSubmit: PropTypes.func.isRequired,
};
export function ComponentPropertiesForm({ editableComponent, onSubmit }) {
    return (_jsx(_Fragment, { children: editableComponent && editableComponent.fields ? (_jsx(FormEngine, { name: "field_props", id: "field_props", onSubmitHandler: onSubmit, formData: editableComponent })) : (_jsx("p", { style: { color: '#666', fontStyle: 'italic', padding: '1rem' }, children: "Select a component type above to configure its properties." })) }));
}
